module.exports = __webpack_public_path__ + "static/media/window-maximize.50b52a9c.svg";